export default __webpack_public_path__ + "static/media/fetr.75ded05f.jpg";